var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.36787 1.5C5.43487 1.5 2.25 4.692 2.25 8.625C2.25 12.558 5.43487 15.75 9.36787 15.75C13.308 15.75 16.5 12.558 16.5 8.625C16.5 4.692 13.308 1.5 9.36787 1.5ZM9.37502 14.325C6.22577 14.325 3.67502 11.7743 3.67502 8.625C3.67502 5.47575 6.22577 2.925 9.37502 2.925C12.5243 2.925 15.075 5.47575 15.075 8.625C15.075 11.7743 12.5243 14.325 9.37502 14.325ZM8.66249 5.0625H9.73124V8.80312L12.9375 10.7055L12.4031 11.5819L8.66249 9.3375V5.0625Z",
    fill: "#6BBBAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.856882102e2583ba666dfa9bc1256f41.svg";
export { ForwardRef as ReactComponent };